export type Auswahl = { slots: number[]; anker: number | null; bereich: string | null };

export const LEER: Auswahl = { slots: [], anker: null, bereich: null };

export function rahmen(von: number, bis: number, spalten: number): number[] {
  const [r1, c1, r2, c2] = [Math.floor(von / spalten), von % spalten, Math.floor(bis / spalten), bis % spalten];
  const aus: number[] = [];
  for (let r = Math.min(r1, r2); r <= Math.max(r1, r2); r++) {
    for (let c = Math.min(c1, c2); c <= Math.max(c1, c2); c++) aus.push(r * spalten + c);
  }
  return aus;
}

export function klick(_a: Auswahl, i: number): Auswahl {
  return { slots: [i], anker: i, bereich: null };
}

export function umschaltKlick(a: Auswahl, i: number, spalten: number): Auswahl {
  if (a.anker === null) return klick(a, i);
  return { slots: rahmen(a.anker, i, spalten), anker: a.anker, bereich: null };
}

export function strgKlick(a: Auswahl, i: number): Auswahl {
  const slots = a.slots.includes(i) ? a.slots.filter((s) => s !== i) : [...a.slots, i].sort((x, y) => x - y);
  return { slots, anker: i, bereich: null };
}
